import { render } from "./ListagemPicking.vue?vue&type=template&id=63f397b3&scoped=true"
import script from "./ListagemPicking.vue?vue&type=script&lang=js"
export * from "./ListagemPicking.vue?vue&type=script&lang=js"

import "./ListagemPicking.vue?vue&type=style&index=0&id=63f397b3&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f397b3"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QSelect,QInput,QIcon,QPopupProxy,QDate,QBtn,QTable,QCardSection,QTd,QPagination});qInstall(script, 'directives', {ClosePopup});
